import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { CookieSettingsModule } from "@obg/mat.ui.common";
import { DialogLayoutModule } from "@obg/mat.ui.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { ComponentFactoryService } from "@obg/ngx.ui.core";

import { CookieSettingsDialogContainer } from "./cookie-settings-dialog.container";

const DIRECTIVES = [CookieSettingsDialogContainer];

@NgModule({
	imports: [CommonModule, CoreContentModule, DialogLayoutModule, CookieSettingsModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class CookieSettingsDialogModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, ...DIRECTIVES);
	}
}
